import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import styles from '../new-jss';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Edit from '@material-ui/icons/Edit';
import IconImage from '@material-ui/icons/Image';
import { fetchCall } from '../../../service/service_base';
import CardButton from './CardButton';
import Grid from '@material-ui/core/Grid/Grid';
import AddContentSection from '../../New/CardButton/AddContentSection';
import { savePortrait } from '../../../service/s3Amplify';
import ls from 'local-storage';
import Loader from '../../Loader/Loader';
import ConfirmDialog from '../../Dialog/ConfirmDialog';
import Snackbar from '@material-ui/core/Snackbar';
import CustomNotification from '../../Notification/CustomNotification';
import { Language } from '@material-ui/icons';

class CardButtonNew extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      portadas: [],
      openAddContentSection: false,
      isLoading: true,
      openConfirmDialog: false,
      openNotification: false,
      typeNotification: "info",
      messageNotification: "",
      portraitSelected: null,
      idDeleted: 0,
      action: '',
      empty: []
    }
  }

  componentDidMount() {
    this._loadCard();
  }

  handleCloseNotification = () => {
    this.setState({
      openNotification: false
    })
  }

  _loadCard = () => {

    fetchCall("POST", "/synthesis/getcontent", {
      sectionId: this.props.section.sec_id,
      isPublish: this.props.isPublish,
      idPublish: this.props.idPublish
    }).then(response => {
      let empty = this.props.type === 'Portada' ? [1, 2] : [1];
      if (response.data.length > 0)
        empty.splice(0, response.data.length)
      this.setState({
        portadas: response.data,
        empty: empty,
        isLoading: false
      })
    }).catch(err => console.log(err));
  }

  _handleAddNewPortrait = (section) => {
    this.setState({
      openAddContentSection: true,
      portraitSelected: null,
      action: "Nueva"
    })
  }

  closeAddContentSection = () => {
    this.setState({
      openAddContentSection: false,
      portraitSelected: null
    });
  }

  saveContent = (event, data, attachment) => {
    event.preventDefault();
    this.setState({ isLoading: true });

    if (data.title.toString().trim() === '') {
      this.setState({
        openNotification: true,
        messageNotification: 'Debes agregar un título',
        typeNotification: "warning",
        isLoading: false
      });
      return false;
    }

    data.imagePath = '';
    data.sectionId = this.props.section.sec_id;
    data.userId = ls.get("current_user").user_id;
    const sec_name = this.props.section.sec_id;
    let keyS3Attachment = attachment != null ? `${this.props.synthesis}/${sec_name}/attachment/${attachment ? `${new Date().getTime()+"_" + attachment.name }`.replace(/[^0-9A-Z._]+/gi,"-") : ''}` : '';

    if (data.isUpdating) {
      Promise.all([(attachment? savePortrait(keyS3Attachment, attachment, attachment.type):null)])
        .then(response => {
          data.attachment = response[0]!==null? response[0].key:this.state.portraitSelected.cont_attachment;
          fetchCall("POST", "/synthesis/updatecontent", data).then(response => {
          if (response.status == 200) {
            this.setState({
              openNotification: true,
              messageNotification: 'Contenido actualizado',
              typeNotification: "success",
              isLoading: false,
              portraitSelected: null,
              openAddContentSection: false,
              empty:[]
            });
            this._loadCard();
          }
        }).catch(err => err);
        })
    } else {
      
      data.order = this.state.portadas.length + 1
      data.idPublish = this.props.idPublish
      Promise.all([(attachment? savePortrait(keyS3Attachment, attachment, attachment.type):null)])
        .then(response => {
          data.attachment = response[0]!==null? response[0].key:null;
          fetchCall("POST", "/synthesis/addcontent", data).then(response => {
            this.setState({
              openNotification: true,
              messageNotification: 'Contenido guardado',
              typeNotification: "success",
              portraitSelected: null,
              openAddContentSection:false,
              empty:[]
            });
            this._clearData();
            setTimeout(() => { this._loadCard(); }, 1500);
          }).catch(err => err);
        })
    }
  }
  
  _editPortrait = (item) => {
    this.setState({
      openAddContentSection: false,
      portraitSelected: null
    }, () => {
      this.setState(
        {
          openAddContentSection: true,
          portraitSelected: item,
          action: "Editar"
        }
      )
    })
  }

  _removeContent = () => {
    this.setState({ isLoading: true });
    fetchCall("POST", "/synthesis/removecontentsection", {
      contId: this.state.idDeleted,
      userId: ls.get("current_user").user_id
    }).then(response => {
      if (response.status == 200) {
        this.setState({
          openConfirmDialog: false,
          isLoading: false,
          openNotification: true,
          messageNotification: 'Contenido eliminado',
          typeNotification: "success"
        });
        this._loadCard();
      }
    }).catch(err => console.log(err));
  }

  openConfirmDelete = (item) => {
    this.setState({
      openConfirmDialog: true,
      idDeleted: item.cont_id
    })
  }

  _closeConfirmDialog = () => {
    this.setState({
      openConfirmDialog: false,
      idDeleted: 0
    })
  }

  _clearData = () => {
    return true;
  }

  moverDerecha = (order) => {
    let sections = this.state.portadas;
    let findElement = sections.findIndex(x => x.cont_order === order);
    var aux = sections[findElement];
    if (sections[findElement + 1] !== undefined) {
      sections[findElement] = sections[findElement + 1];
      sections[findElement].cont_orden = sections[findElement + 1].cont_orden;
      sections[findElement + 1] = aux;
      sections[findElement + 1].cont_orden = aux.cont_orden;

      this.setState({
        portadas: sections
      }, () => {
          fetchCall("POST", "/synthesis/updateorder", {
            order: sections.map((v,k)=>({id:v.cont_id,position:(k + 1)})),
            userId: ls.get("current_user").user_id,
            content: 1
          }).catch(err => console.log(err))
        // });

        this.setState({
          isLoading: false
        });
      });
    }
  }

  moverIzquierda = (order) => {
    let sections = this.state.portadas;
    let findElement = sections.findIndex(x => x.cont_order === order);
    var aux = sections[findElement];
    if (sections[findElement - 1] !== undefined) {
      sections[findElement] = sections[findElement - 1];
      sections[findElement].cont_orden = sections[findElement - 1].cont_orden;
      sections[findElement - 1] = aux;
      sections[findElement - 1].cont_orden = aux.cont_orden;

      this.setState({
        portadas: sections
      }, () => {
        fetchCall("POST", "/synthesis/updateorder", {
          order: sections.map((v,k)=>({id:v.cont_id,position:(k + 1)})),
          userId: ls.get("current_user").user_id,
          content: 1
        }).catch(err => console.log(err))

        this.setState({
          isLoading: false
        });
      });
    }
  }

  render() {
    const {
      classes,
      section,
      canEdit,
      canDelete,
      type,
    } = this.props;

    function SelectIcon(type) {
    
      switch (type) {
        case 'Portada':
          return [
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.73055 19.9455C9.75761 20.1464 9.40361 20.3641 9.22322 20.4479C9.09921 20.2206 8.80383 19.6943 8.61443 19.4072C8.37768 19.0483 7.73506 18.5459 7.3292 18.3306C6.92334 18.1152 7.3292 16.9669 6.99098 16.4644C6.65276 15.962 6.17926 15.5673 5.50282 15.3878C4.96167 15.2443 4.646 14.5624 4.55581 14.2395L5.50282 14.5983L5.80722 13.6653L4.55581 12.3016V11.9068L3.94701 11.0097L3 9L5.33371 9.21532C5.99887 9.62204 7.54566 10.5072 8.4115 10.7943C9.27734 11.0814 10.5536 11.1771 11.0834 11.1891V10.0766C11.1511 10.1962 11.3675 10.4355 11.6922 10.4355H12.7407C12.8083 10.591 13.0113 10.9594 13.2818 11.1891C13.6201 11.4762 14.0598 11.4044 14.2289 11.5838C14.398 11.7633 14.4318 12.3016 14.6347 12.5169C14.8377 12.7322 14.8377 13.0552 15.0744 13.2705C15.2638 13.4428 15.8523 13.5098 16.1229 13.5217C16.3371 13.115 16.8331 12.3016 17.1037 12.3016C17.4419 12.3016 17.8816 12.6963 18.3213 13.2705C18.761 13.8447 18.7948 14.4189 18.7948 14.5983C18.7948 14.7419 19.336 14.8017 19.6065 14.8137C19.6291 15.2443 19.7621 16.1774 20.1139 16.4644C20.4656 16.7515 21.3202 16.6798 21.7035 16.608L21.2976 17.8999V19.4072C21.2976 19.8019 21.5006 19.9455 21.7035 20.5914C21.9064 21.2374 21.7373 21.5245 21.9064 21.991C22.0755 22.4575 22.6843 22.4934 23.0564 22.8882C23.4284 23.2829 23.3946 24.6466 23.8681 24.8261C24.3416 25.0055 24.8151 24.4672 25.018 24.4672C25.221 24.4672 25.0519 25.0055 25.2886 25.1849C25.5254 25.3644 26.54 25.1132 26.9121 25.0055C27.2097 24.9194 28.186 24.6107 28.637 24.4672C28.6933 24.3236 28.8061 23.972 28.8061 23.7136C28.8061 23.3906 29.1105 23.1753 29.3134 22.8882C29.5163 22.6011 29.3134 22.2781 29.3134 21.991V21.1656H29.8207C29.956 21.1656 30.3506 20.9024 30.531 20.7709L31.2751 20.5914H33L32.3574 21.991C32.3236 22.4216 32.2424 23.3691 32.1883 23.7136C32.1206 24.1442 31.5795 23.5341 31.4442 23.7136C31.3089 23.893 31.478 24.4313 30.9369 24.8261C30.3957 25.2208 29.3472 25.3285 29.1105 25.3644C28.8737 25.4003 28.7384 25.795 28.8061 26.0821C28.8737 26.3692 29.6516 26.8357 29.6516 27.0152C29.6516 27.1587 28.8399 27.1946 28.434 27.1946L28.1973 28.2712C28.0733 28.3908 27.7576 28.5942 27.487 28.4506C27.1488 28.2712 26.2356 27.2305 25.8298 27.0152C25.4239 26.7998 24.9166 27.3022 24.646 27.5535C24.3754 27.8047 23.8343 27.8047 23.6652 27.9123C23.4961 28.02 22.5829 27.7329 22.2108 27.5535C21.8388 27.374 21.4329 27.5893 21.1623 27.5535C20.8918 27.5176 20.5536 27.051 20.2153 26.8357C19.8771 26.6204 19.133 26.8716 18.7948 26.8357C18.4566 26.7998 17.8478 26.118 17.6787 26.0821C17.5096 26.0462 17.1375 26.0103 16.5964 25.795C16.0552 25.5797 15.7847 25.149 15.5817 24.8261C15.4194 24.5677 15.018 24.7184 14.8377 24.8261C14.7024 24.6347 14.3912 24.1442 14.2289 23.7136C14.0259 23.1753 14.2289 22.6729 14.4318 22.4934C14.6347 22.314 14.398 21.9192 14.2289 21.7398C14.0598 21.5604 13.823 21.2374 13.5186 20.4479C13.2142 19.6584 12.4701 19.2277 12.1995 19.0483C11.929 18.8689 11.5231 18.2229 11.2864 17.8999C11.0496 17.5769 10.1026 16.9669 10.0011 16.608C9.89966 16.2491 9.73055 15.7467 9.39233 15.5673C9.05411 15.3878 8.91883 15.1725 8.85118 14.8137C8.78354 14.4548 8.31003 14.4548 8.00564 14.4189C7.70124 14.383 7.83653 13.45 7.49831 13.2705C7.16009 13.0911 7.12627 12.5169 6.99098 12.3016C6.85569 12.0863 6.58512 11.4762 6.58512 11.1891C6.58512 10.902 5.33371 9.71773 5.50282 10.4355C5.63811 11.0097 5.44645 11.6556 5.33371 11.9068C5.40135 12.0025 5.61105 12.2944 5.90868 12.6963C6.28072 13.1987 6.5513 14.5983 6.58512 14.8137C6.61894 15.029 7.66742 15.962 8.00564 16.608C8.34386 17.254 8.51296 18.2588 8.61443 18.5459C8.7159 18.833 8.98647 18.833 9.39233 18.8689C9.7982 18.9047 9.69673 19.6943 9.73055 19.9455Z" fill="currentColor"/>
              </svg>,
              <Language />,
            ]
        case 'Editoriales':
          return [
              <Edit />
            ]
        case 'Cartones':
          return [
            <IconImage />
          ]
        default:
          return null;
      }
    }

    const iconInBtn = SelectIcon(type)
    return (
      <div>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={this.state.openNotification}
          autoHideDuration={6000}
          onClose={this.handleCloseNotification}>
          <CustomNotification
            onClose={this.handleCloseNotification}
            variant={this.state.typeNotification}
            message={this.state.messageNotification} />
        </Snackbar>
        <Grid container >
          <Grid item xs={12}>
            <Grid
              container
              spacing={8}
              alignItems="center"
              direction="row"
              justify="center"
              className={classes.portadas}
            >
              {
                this.state.isLoading ? <Loader text={"Cargando..."} /> :

                  this.state.portadas.map((item, index) => {
                    item.cont_imagePath = item.cont_key
                    item.cont_attachment = item.cont_attachmentKey
                    return (
                      <Grid key={index.toString()} item>
                        <CardButton canEdit={canEdit} canDelete={canDelete} attachment={item.cont_attachmentKey} image={item.cont_imagePath} edit={() => this._editPortrait(item)} remove={() => this.openConfirmDelete(item)} moverDerecha={() => this.moverDerecha(item.cont_order)} moverIzquierda={() => this.moverIzquierda(item.cont_order)} text={item.cont_name} 
                        icon={iconInBtn[index]}/>
                      </Grid>
                    )
                  })
              }
              {this.state.empty.map(e => {
                return (
                  <Grid key={e} item>
                    <div className={classes.portadaNew}>
                      <div className={classes.contentBtnNew}>
                        <Tooltip title="Nuevo Contenido">
                          <Button variant="fab" onClick={() => { this._handleAddNewPortrait(section) }} mini aria-label="add" className={classes.btnNew} disabled={!canEdit}>
                            <AddIcon />
                          </Button>
                        </Tooltip>
                      </div>
                    </div>
                  </Grid>
                );
              })}

            </Grid>
          </Grid>
        </Grid>

        <AddContentSection
          openForm={this.state.openAddContentSection}
          closeForm={this.closeAddContentSection}
          classes={classes}
          submit={this.saveContent}
          dataInit={this.state.portraitSelected}
          contentType={section.cont_tipo}
          action={this.state.action}
          clearData={this._clearData}
          isLoading={this.state.isLoading}
        />

        <ConfirmDialog
          title={"¿Desea eliminar la portada?"}
          message={"La información de la portada no podrá recuperarse"}
          textAccept={"Aceptar"}
          textCancel={"Cancelar"}
          funcAccept={this._removeContent}
          funcCancel={this._closeConfirmDialog}
          open={this.state.openConfirmDialog}
        />
      </div>

    );
  }
}

CardButtonNew.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
  submit: PropTypes.func,
  section: PropTypes.object,
  canEdit: PropTypes.bool,
  canDelete: PropTypes.bool,
  type: PropTypes.string,
};

export default withStyles(styles)(CardButtonNew);
